module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "culturalhistory"
  }, [_c('div', {
    staticClass: "bannerbg",
    on: {
      "click": function($event) {
        return _vm.handlevideoAction()
      }
    }
  }, [_c('img', {
    staticClass: "bannerbg_pic",
    attrs: {
      "src": require("@/assets/images/mainindex/jingwai-banner@2x.jpg")
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "container_wrap"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "zhou-wrap"
  }, [_c('div', [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'jingwaiZhou',
        query: {
          cate_id: 127
        }
      }),
      expression: "{ name: 'jingwaiZhou', query: { cate_id: 127 } }"
    }],
    attrs: {
      "src": require("@/assets/images/mainindex/pic-zhou1.jpg")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'jingwaiZhou',
        query: {
          cate_id: 124
        }
      }),
      expression: "{ name: 'jingwaiZhou', query: { cate_id: 124 } }"
    }],
    attrs: {
      "src": require("@/assets/images/mainindex/pic-zhou2.jpg")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'jingwaiZhou',
        query: {
          cate_id: 126
        }
      }),
      expression: "{ name: 'jingwaiZhou', query: { cate_id: 126 } }"
    }],
    attrs: {
      "src": require("@/assets/images/mainindex/pic-zhou3.jpg")
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'jingwaiZhou',
        query: {
          cate_id: 125
        }
      }),
      expression: "{ name: 'jingwaiZhou', query: { cate_id: 125 } }"
    }],
    attrs: {
      "src": require("@/assets/images/mainindex/pic-zhou4.jpg")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'jingwaiZhou',
        query: {
          cate_id: 128
        }
      }),
      expression: "{ name: 'jingwaiZhou', query: { cate_id: 128 } }"
    }],
    attrs: {
      "src": require("@/assets/images/mainindex/pic-zhou5.jpg")
    }
  })])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "news_info container_wrap"
  }, [_c('div', {
    staticClass: "news_info_content"
  }, [_vm._l((_vm.row.news.slice(0, 1)), function(item, index) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'CmsDetail',
          query: {
            id: item.id
          }
        }),
        expression: "{ name: 'CmsDetail', query: { id: item.id } }"
      }],
      key: item.id,
      staticClass: "news_info_left"
    }, [_c('img', {
      attrs: {
        "src": item.pic_url,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "news_info_desc"
    }, [_c('div', {
      staticClass: "news_info_desc_title"
    }, [_vm._v("\n            " + _vm._s(item.title) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "news_info_desc_subtitle"
    }, [_vm._v("\n            " + _vm._s(item.desc) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "news_info_desc_nums"
    }, [_c('div', {
      staticClass: "news_info_desc_nums_date"
    }, [_vm._v(" " + _vm._s(_vm._f("formatDate")(item.create_time)))]), _vm._v(" "), _c('div', {
      staticClass: "news_info_desc_nums_fire"
    }, [_vm._v(_vm._s(item.views_count))])]), _vm._v(" "), _c('div', {
      staticClass: "news_info_desc_jump"
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "news_info_right"
  }, [_vm._l((_vm.row.news.slice(1, 6)), function(item, index) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'CmsDetail',
          query: {
            id: item.id
          }
        }),
        expression: "{ name: 'CmsDetail', query: { id: item.id } }"
      }],
      key: item.id,
      staticClass: "news_info_right_items"
    }, [_c('div', {
      staticClass: "news_info_right_item"
    }, [_c('div', {
      staticStyle: {
        "background": "#0000006e",
        "position": "absolute",
        "width": "100%",
        "height": "100%",
        "z-index": "10"
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": item.pic_url,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "news_info_right_item_date"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.create_time)))]), _vm._v(" "), _c('div', {
      staticClass: "news_info_right_item_title"
    }, [_vm._v("\n              " + _vm._s(item.title) + "\n            ")])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: 12
        }
      }),
      expression: "{ name: 'NewsList', query: { cate_id: 12 } }"
    }],
    staticClass: "news_info_right_items"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4)])], 2)], 2)]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "faq-wrap"
  }, [_c('div', [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CmsDetail',
        query: {
          id: 668
        }
      }),
      expression: "{ name: 'CmsDetail', query: { id: 668 } }"
    }],
    attrs: {
      "src": require("@/assets/images/mainindex/pic-faq1.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CmsDetail',
        query: {
          id: 669
        }
      }),
      expression: "{ name: 'CmsDetail', query: { id: 669 } }"
    }],
    attrs: {
      "src": require("@/assets/images/mainindex/pic-faq2.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CmsDetail',
        query: {
          id: 670
        }
      }),
      expression: "{ name: 'CmsDetail', query: { id: 670 } }"
    }],
    attrs: {
      "src": require("@/assets/images/mainindex/pic-faq3.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CmsDetail',
        query: {
          id: 671
        }
      }),
      expression: "{ name: 'CmsDetail', query: { id: 671 } }"
    }],
    attrs: {
      "src": require("@/assets/images/mainindex/pic-faq4.png")
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bannerbg_desc"
  }, [_c('div', {
    staticClass: "bannerbg_desc_title"
  }, [_vm._v("境外交流")]), _vm._v(" "), _c('div', {
    staticClass: "bannerbg_desc_entitle"
  }, [_vm._v("OVERSEAS COMMUNICATION")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jingwai-title"
  }, [_c('span', {
    staticClass: "jingwai-title-1"
  }, [_vm._v("境外活动")]), _c('span', {
    staticClass: "jingwai-title-2"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jingwai-title"
  }, [_c('span', {
    staticClass: "jingwai-title-1"
  }, [_vm._v("活动新闻")]), _c('span', {
    staticClass: "jingwai-title-2"
  }, [_vm._v("News")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news_info_right_item_last_count"
  }, [_vm._v("9999"), _c('sup', [_vm._v("+")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news_info_right_item_last_more"
  }, [_vm._v("\n            更多精彩"), _c('i', {
    staticClass: "el-icon-d-arrow-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jingwai-title"
  }, [_c('span', {
    staticClass: "jingwai-title-1"
  }, [_vm._v("常见问题")]), _c('span', {
    staticClass: "jingwai-title-2"
  }, [_vm._v("FAQs")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb704da4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/jingwai.vue
// module id = 1616
// module chunks = 0